import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('machines_requisition')
export class MachinesRequisitionEntity{

    @PrimaryGeneratedColumn('increment',{name:'machines_requisition_id'})
    machinesReqId : number;

    @Column('varchar',{
        name:'sepl'
    })
    sepl: string;

    @Column('varchar',{
        name:'unit'
    })
    unit: string;

    @Column('varchar',{
        name:'mntch_fm'
    })
    mntcfm: string;

    @Column('varchar',{
        name:'rev'
    })
    rev: string;

    @Column('datetime',{
        name:'date'
    })
    date: Date;

    @Column('varchar',{
        name:'to'
    })
    to: string;

    @Column('varchar',{
        name:'unit_1'
    })
    unit_1: string;

    @Column('varchar',{
        name:'style'
    })
    style: string;

    @Column('datetime',{
        name:'date_1'
    })
    dateOne: Date;

    @Column('int',{
        name:'PO_Nos'
    })
    poNOs: number;

    @Column('varchar',{
        name:'buyer'
    })
    buyer: string;

    @Column('varchar',{
        name:'orderQty'
    })
    orderQty: string;

    @Column('varchar',{
        name:'machine_desc'
    })
    machineDesc: string;

    @Column('int',{
        name:'no_of_batches'
    })
    noOfBatches: number;

    @Column('int',{
        name:'no_of_machines_req_per_batch'
    })
    noOfMachinesReqPerBatch: number;

    @Column('int',{
        name:'total_machines_required'
    })
    totalMachinesRequired: number;

    @Column('varchar',{
        name:'at_present_holding_machines_particular_style'
    })
    atPresentHoldingMachinesParticularStyle: string;

    @Column('varchar',{
        name:'extra_machines_required_particular_style'
    })
    extraMachinesRequiredParticularStyle: string;

    @Column('int',{
        name:'total_machines_existing_in_the_unit'
    })
    totalMachinesExistingInTheUnit: number;

    @Column('datetime',{
        name:'date_of_machines_required'
    })
    dateOfMachinesRequired: Date;

    @Column('int',{
        name:'no_of_days_machines_required'
    })
    noOfDaysMachinesRequired: number;
  
    @Column('varchar',{
        name:'prepared_by'
    })
    preparedBy: string;

    @Column('varchar',{
        name:'approved_by'
    })
    approvedBy: string;

    @Column('varchar',{
        name:'authored_by'
    })
    authoredBy: string;

    @Column('varchar',{
        name:'note'
    })
    note: string;

    @Column('varchar',{
        name:'received_by'
    })
    receivedBy: string;

    @Column('datetime',{
        name:'received_on'
    })
    receivedOn: Date;

    @Column("boolean", {
        nullable: false,
        name: "is_active",
        default: true
    })
    isActive: boolean | null;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
}